import changeIsLoading from 'mini-options-store/lib/actions/changeIsLoading';
import { initEventsAndInvitesOption } from '../../actions/eventsAndInvites/initEventsAndInvitesOption';
import { loadEventsAndInvitesOption } from '../../actions/eventsAndInvites/loadEventsAndInvitesOption';
import { orchestrator } from 'satcheljs';
import {
    lazyInitCalendarCloudSettings,
    isCalendarCloudSettingsInitialized,
} from 'mini-calendar-cloud-settings';

export const loadEventsAndInvitesOptionOrchestrator = orchestrator(
    loadEventsAndInvitesOption,
    async () => {
        // initialise the view state
        initEventsAndInvitesOption();

        if (!isCalendarCloudSettingsInitialized()) {
            // start loading
            changeIsLoading(true);

            // Initialize calendar cloud settings store and then view state
            await lazyInitCalendarCloudSettings.importAndExecute();
            initEventsAndInvitesOption();

            // stop loading
            changeIsLoading(false);
        }
    }
);
